import script from "./ScheduleFrequencyManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleFrequencyManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleFrequencyManagement.vue?vue&type=style&index=0&id=099456e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099456e8"]])

export default __exports__